import { useSnackbar } from 'notistack';
import { exportQuote } from 'store/slices/marketplace';
import { useAsyncDispatch } from 'hooks/useAsyncDispatch';

export const useQuote = () => {
  const dispatchAction = useAsyncDispatch();

  const { enqueueSnackbar } = useSnackbar();

  const handleExportQuote = (quoteId, download) => {
    if (!quoteId) return null;

    dispatchAction(exportQuote({ quoteId, download }), {
      onSuccess: () => {
        enqueueSnackbar(`Quote has been successfully ${download ? 'downloaded' : 'exported'}.`);
      },
    });
  };

  return {
    handleExportQuote,
  };
};
